import useSearchResults from "@/src/hooks/srp/useSearchResults"
import { FlightCard } from '@/src/types/flight'
import { getRouteSummaries } from "@/src/utils/srp/routeUtils"
import { Box } from "@mui/material"
import { useLocale, useTranslations } from "next-intl"
import { useMemo } from "react"
import { TabItem } from "./tabItem"

export const StepTabs = ({
    onwardFlightData,
    onChangeOnwardSelection,

}: {
    onwardFlightData: FlightCard | null
    onChangeOnwardSelection?: () => void

}) => {
    const tCommon = useTranslations('common')
    const locale = useLocale()
    const isArabic = locale === 'ar'
    const { jsons, selectedJourneyLeg: selectedLeg } = useSearchResults()
    const routes = useMemo(() => {
        const sectionArr = Object.values(jsons?.secs || {})
        console.log('sectionArr', sectionArr)
        const route = getRouteSummaries(sectionArr, jsons?.ap || {}, isArabic)
        return route
    }, [jsons?.secs, jsons?.ap, isArabic])
    // const flightData = useGetRTSolutionCardData(onwardFlightData)




    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault()
        e.stopPropagation()
        onwardFlightData && onChangeOnwardSelection?.()
    }

    return (

        <Box
            display={'flex'}
            alignItems={'center'}
            gap={1}
            borderBottom={'1px solid #E0E0E0'}
            px={2}
            color={"#000"}
            justifyContent={"space-between"}
            minHeight={"45px"}
        >
            {
                routes.map((route, index) => {
                    const isActive = index === selectedLeg
                    const isOnward = index === 0
                    return (

                        <TabItem
                            key={index}
                            isActive={isActive}
                            handleClick={handleClick}
                            isOnward={isOnward}
                            onwardFlightData={onwardFlightData}
                            route={route}
                            tCommon={tCommon}
                            isArabic={isArabic}
                            selectedLeg={selectedLeg}
                        />


                    )
                })
            }
        </Box>



    )
}
